import { createSlice } from '@reduxjs/toolkit';
import { DeductionState } from './deductionTypes';
import { 
  createDeduction, 
  fetchDeductions, 
  fetchDeductionById, 
  updateDeduction, 
  deleteDeduction 
} from './deductionActions';

const initialState: DeductionState = {
  deductions: [],
  selectedDeduction: undefined,
  loading: false,
  error: undefined,
};

const deductionSlice = createSlice({
  name: 'deduction',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create Deduction
      .addCase(createDeduction.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(createDeduction.fulfilled, (state, action) => {
        state.loading = false;
        state.deductions.push(action.payload);
      })
      .addCase(createDeduction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch All Deductions
      .addCase(fetchDeductions.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchDeductions.fulfilled, (state, action) => {
        state.loading = false;
        state.deductions = action.payload.data;
      })
      .addCase(fetchDeductions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch Deduction by ID
      .addCase(fetchDeductionById.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchDeductionById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedDeduction = action.payload;
      })
      .addCase(fetchDeductionById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Deduction
      .addCase(updateDeduction.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(updateDeduction.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.deductions.findIndex(deduction => deduction.id === action.payload.id);
        if (index !== -1) {
          state.deductions[index] = action.payload;
        }
      })
      .addCase(updateDeduction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Delete Deduction
      .addCase(deleteDeduction.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(deleteDeduction.fulfilled, (state, action) => {
        state.loading = false;
        state.deductions = state.deductions.filter(deduction => deduction.id !== action.payload.id);
      })
      .addCase(deleteDeduction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default deductionSlice.reducer;
